import ContentSettings from './ContentSettings';

export default ContentSettings;
